import { defineComponent as h, computed as l, openBlock as i, createElementBlock as s, createElementVNode as t, toDisplayString as d, createCommentVNode as n, normalizeStyle as f, createStaticVNode as v } from "vue";
const p = ["viewBox"], m = /* @__PURE__ */ t("mask", { id: "321f1d7b-2b64-41a8-83f4-eada5ed6ee9a" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), _ = { mask: "url(#321f1d7b-2b64-41a8-83f4-eada5ed6ee9a)" }, u = { key: 0 }, k = /* @__PURE__ */ v('<path fill="#0052b4" d="M256 0h256v512H0V256Z"></path><path fill="#eee" d="M0 0v32l32 32L0 96v160h32l32-32 32 32h32v-83l83 83h45l-8-16 8-15v-14l-83-83h83V96l-32-32 32-32V0H96L64 32 32 0Z"></path><path fill="#d80027" d="M32 0v32H0v64h32v160h64V96h160V32H96V0Zm96 128 128 128v-31l-97-97z"></path><circle cx="382" cy="256" r="74" fill="#eee"></circle><path fill="#338af3" d="M405 322.1 382 312l-23 10.2 23-66.1zm0-132.2L382 200l-23-10.2 23 66.1zM315.9 279l10.2-23-10.2-23 66.1 23zm132.2 0L438 256l10.2-23-66.1 23z"></path><path fill="#ffda44" d="M377 228v5h-5v10h5v9.4a15.2 15.2 0 0 0-20.7 22.2v9.4H408v-9.4a15.2 15.2 0 0 0-20.7-22.2V243h5v-10h-5v-5z"></path>', 6), g = { fill: "none" }, V = ["r"], y = /* @__PURE__ */ h({
  __name: "au-qld",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(c) {
    const e = c, o = l(() => 512 + 2 * e.strokeWidth), a = l(() => -e.strokeWidth), r = l(() => 256 + e.strokeWidth / 2);
    return (x, z) => (i(), s("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${a.value} ${a.value} ${o.value} ${o.value}`
    }, [
      m,
      t("g", _, [
        e.flagName ? (i(), s("title", u, d(e.flagName), 1)) : n("", !0),
        k
      ]),
      t("g", g, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: r.value,
          fill: "none",
          style: f({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, V)
      ])
    ], 8, p));
  }
});
export {
  y as default
};
//# sourceMappingURL=au-qld-6f666951.js.map
